import UserIcon from './UserIcon'

export default UserIcon
